import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Modal, Spin, Skeleton, Button, Radio, Flex, Empty, Pagination, notification } from 'antd';
import { useProductData } from '../../hooks/ProductHooks';
import { LoadingOutlined, RightOutlined, LeftOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import DownloadButton from '../download/DownloadButton';
import FormSlider from '../elements/FormSlider';
import { useTranslation } from 'react-i18next';
import ProductImagesCarousel from './ProductImagesCarousel';
import { useBrowser } from '../../contexts/BrowserContext';
import { CLIENT_TYPE } from '../../config';
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_PRODUCT_MODAL_DATA_LIST, FETCH_COLLECTION_MODAL_DATA_LIST, FETCH_DISLIKE_COLLECTION, FETCH_DRAWER_MENU, FETCH_LIKE_COLLECTION, FETCH_PRODUCT_LIST, FETCH_PRODUCT_MODAL_DATA_LIST } from "../../redux/actions";
import { setSelectedId } from "../../redux/slices/selectItemDrawerMenu";
import { setSelectedProductId } from "../../redux/slices/selectProductId";
import { useLocation } from "react-router-dom";
import { setCurrentPage } from "../../redux/slices/currentPageSlice";
import { setLikeFormId } from "../../redux/slices/likeFormIdSlice";
import { FETCH_DISLIKE, FETCH_LIKE } from "../../redux/actions";
import { setLikeStatus } from '../../redux/slices/likeStatus';
import { setLikeCollectionId } from '../../redux/slices/likeCollectionIdSlice';
import CollectionList from './CollectionList';
import CategoryFilesList from './CategoryFilesList';
import ProductModal from './ProductModal';

const ShowMoreProductList = ({ sectionTitle, showMore, loadMore, showSort, showCategory, category, view, data, status, isCollection, name }) => {

    const isAuthenticated = useSelector((state) => state.initialize.isAuthenticated);
    const selectedId = useSelector((state) => state.selectItemDrawerMenu.selectedId);

    const location = useLocation();
    let curruntPage = location.pathname
    const loading = useSelector((state) => state.loading);


    let curruntPageFlag = curruntPage === '/show-more-collection'


    const dispatch = useDispatch();
    const { hasMore, products, fetchMoreProducts, likeAndDislike } = useProductData(category);
    const [open, setOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [like, setLike] = useState(false);
    const [profileType, setProfileType] = useState("all");
    const [productId, setProductId] = useState(null);
    const { browser } = useBrowser();
    const [renderOptions, setRenderOptions] = useState({ psb: "planar", uvw: 50, hue_shift: 0, saturation: 0, brightness: 0, contras: 0 });
    const toggleMoreOptions = () => {
        setShowMoreOptions(!showMoreOptions);
    };
    const [currentPages, setCurrentPages] = useState(data?.meta?.current_page);
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [nextDisable, setNextDisable] = useState(false)
    const [prevDisable, setPrevDisable] = useState(false)
    const [likedItems, setLikedItems] = useState({});
    const [product, setProduct] = useState(null);
    const { productModalData } = useSelector((state) => state?.productModalData)


    const { t } = useTranslation();

    const handlePageChange = (page) => {
        setCurrentPages(page);
        dispatch(setCurrentPage(page));
    };



    const handleSelectedProductId = (id, selectId) => {
        dispatch({ type: CLEAR_PRODUCT_MODAL_DATA_LIST })
        setProductId(id)
        dispatch(setSelectedProductId(id));
        let selectedIndex;
        let files = data?.id === selectId && data?.data
        selectedIndex = files?.findIndex(item => item.id === id)
        setSelectedIndex(selectedIndex)
        dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });

    };



    const handleSelectedCategoryId = (id) => {
        dispatch(setSelectedId(id));
    }


    const toggleLike = (id, isLiked) => {
        dispatch(setLikeFormId(id));
        setLikedItems((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
        if (!isAuthenticated) {
            notification.error({
                message: "To register likes for forms, please Login first.",
                description: "You are not logged in yet. Your likes will not be registered in the system.",
                placement: "topRight",
            });
            setTimeout(() => {
                setLikedItems({})
            }, 5000)
        } else {
            dispatch({ type: isLiked ? FETCH_DISLIKE : FETCH_LIKE });
        }
        dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
    };




    useEffect(() => {
        if (data?.meta?.links) {
            const activeLink = data.meta.links.find(link => link.active);
            if (activeLink) {
                dispatch(setCurrentPage(Number(activeLink.label)));
            } else {
                dispatch(setCurrentPage(1))
            }
        }
    }, [data]);


    const handleInfiniteScroll = () => {
        console.log("fetch more");
        fetchMoreProducts();
    };
    const generateKey = (pre) => {
        return `${pre}_${new Date().getTime()}_${Math.random()}`;
    }

    useEffect(() => {
        if (isCollection) {
            if (data?.is_collection) {
                // For collections
                setPrevDisable(selectedIndex === 0);
                setNextDisable(selectedIndex === data.collections?.length - 1);
            } else {
                // For files
                setPrevDisable(selectedIndex === 0);
                setNextDisable(selectedIndex === data.files?.length - 1);
            }
        } else {
            // For other data structures
            setPrevDisable(selectedIndex === 0);
            setNextDisable(selectedIndex === data?.data?.length - 1);
        }
    }, [selectedIndex, open, data, isCollection]);

    useEffect(() => {
        setProduct(productModalData)
    }, [handleSelectedProductId])

    useEffect(() => {
        dispatch(setCurrentPage(1));
    }, [selectedId])

    return loading ? (

        <>
            {sectionTitle !== "" && typeof sectionTitle !== "undefined" ? <h2 className='section-title'>{sectionTitle}</h2> : null}
            {
                view === "list" ?
                    <Spin
                        indicator={
                            <LoadingOutlined
                                style={{
                                    fontSize: 24,
                                }}
                                spin
                            />
                        }
                    />
                    :
                    <Row gutter={[10, 10]} >
                        {
                            Array(15).fill(0).map((_, index) => (
                                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                    <Card
                                        hoverable
                                        cover={
                                            <Skeleton.Image
                                                active
                                                className="card-image"
                                                style={{ objectFit: 'cover' }}
                                            />
                                        }
                                        className="product-card loading"
                                    >
                                    </Card>
                                </Col>
                            ))
                        }
                    </Row>

            }
        </>
    ) : (

        <InfiniteScroll
            dataLength={products?.length}
            next={handleInfiniteScroll}
            hasMore={loadMore === true ? hasMore : false}
            scrollableTarget="content-scroll-target"
            loader={<Spin
                className='infinite-scroll-loading'
                indicator={
                    <LoadingOutlined
                        className='loading-spin'
                        spin
                    />
                }
            />}

        >

            {
                view === "list" ? <></> :

                    <Row gutter={[10, 10]} className='scroll-row'>
                        {
                            loading ?
                                (
                                    Array(15).fill(() => (
                                        <Col xs={24} sm={12} md={8} lg={6}>
                                            <Skeleton active />
                                        </Col>
                                    ))
                                ) :
                                (
                                    data ?
                                        <div style={{ width: '100%' }}>
                                            <Flex justify='space-between' align={'center'} style={{ width: '100%' }}>

                                                {
                                                    view !== "list" ?
                                                        <h2 className='section-title'
                                                            style={{ marginBottom: '20px', marginLeft: '5px' }}>{data?.meta?.category?.name ? data.meta.category.name : name}</h2>
                                                        : <></>
                                                }

                                            </Flex>
                                            <div>
                                                {curruntPageFlag || isCollection ? (
                                                    <CollectionList
                                                        collections={data.data}
                                                        handleSelectedProductId={handleSelectedProductId}
                                                        likeAndDislike={likeAndDislike}
                                                        setOpen={setOpen}
                                                        like={like}
                                                        setLike={setLike}
                                                    />
                                                ) : (
                                                    <CategoryFilesList
                                                        files={data.data}
                                                        handleSelectedProductId={handleSelectedProductId}
                                                        likeAndDislike={likeAndDislike}
                                                        setOpen={setOpen}
                                                        like={like}
                                                        setLike={setLike}
                                                        likedItems={likedItems}
                                                        toggleLike={toggleLike}
                                                    />
                                                )}
                                            </div>

                                        </div>
                                        :
                                        <Empty className='products-empty' />
                                )

                        }
                    </Row>
            }
            <Pagination
                current={data?.meta?.current_page}
                pageSize={15}
                total={data?.meta?.total}
                onChange={handlePageChange}
                showSizeChanger={false}
                style={{ marginTop: '50px', marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }}
            />
            {
                status !== 'collection' && product != null &&
                <ProductModal product={product} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} likedItems={likedItems}
                    toggleLike={toggleLike} data={data} open={open} setOpen={setOpen} profileType={profileType} />
            }

        </InfiniteScroll >

    );
}


export default ShowMoreProductList
